module.exports = __webpack_public_path__ + "img/video-pic1.2e82fb06.jpg";